module.exports = __webpack_public_path__ + "static/media/bunnydream.7dd88b90.jpg";